import { render, staticRenderFns } from "./CurrencyText.vue?vue&type=template&id=214ffa48"
import script from "./CurrencyText.vue?vue&type=script&lang=js"
export * from "./CurrencyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports